// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"0fc2319c","359":"34696e02","361":"6dbc3d2e","849":"d645e5f6"}[chunkId] + ".chunk.js";
};